function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M17 19.888l-4.537-4.632a.845.845 0 00-1.212 0 .888.888 0 000 1.238l5.143 5.25a.845.845 0 001.212 0l5.143-5.25a.888.888 0 000-1.238.845.845 0 00-1.212 0L17 19.888z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "currentcolor",
  strokeWidth: 0.8,
  strokeLinecap: "square",
  cx: 17,
  cy: 17,
  r: 17
}));

var SvgArrowExpand = function SvgArrowExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzZweCIgaGVpZ2h0PSIzNnB4IiB2aWV3Qm94PSIwIDAgMzYgMzYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1ICg3ODA3NikgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+R3JvdXAgMjwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMDQuMDAwMDAwLCAtMzUuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwNS4wMDAwMDAsIDM2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iY3VycmVudGNvbG9yIiBkPSJNMTcsMTkuODg3NTYzMSBMMTIuNDYzMjM0NCwxNS4yNTYyODE2IEMxMi4xMjg0OTkzLDE0LjkxNDU3MjggMTEuNTg1Nzg2NCwxNC45MTQ1NzI4IDExLjI1MTA1MTMsMTUuMjU2MjgxNiBDMTAuOTE2MzE2MiwxNS41OTc5OTAzIDEwLjkxNjMxNjIsMTYuMTUyMDA5NyAxMS4yNTEwNTEzLDE2LjQ5MzcxODQgTDE2LjM5MzkwODUsMjEuNzQzNzE4NCBDMTYuNzI4NjQzNiwyMi4wODU0MjcyIDE3LjI3MTM1NjQsMjIuMDg1NDI3MiAxNy42MDYwOTE1LDIxLjc0MzcxODQgTDIyLjc0ODk0ODcsMTYuNDkzNzE4NCBDMjMuMDgzNjgzOCwxNi4xNTIwMDk3IDIzLjA4MzY4MzgsMTUuNTk3OTkwMyAyMi43NDg5NDg3LDE1LjI1NjI4MTYgQzIyLjQxNDIxMzYsMTQuOTE0NTcyOCAyMS44NzE1MDA3LDE0LjkxNDU3MjggMjEuNTM2NzY1NiwxNS4yNTYyODE2IEwxNywxOS44ODc1NjMxIFoiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgICAgICAgICAgICAgPGNpcmNsZSBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLXdpZHRoPSIwLjgiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIGN4PSIxNyIgY3k9IjE3IiByPSIxNyI+PC9jaXJjbGU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgArrowExpand as ReactComponent };